Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ChannelView extends Backbone.View
  template: JST['backbone/templates/settings/topics/channel']
  tagName: 'tr'
  className: 'source nested-fields'

  initialize: ({sourceId, sourceIndex, socialAccountId, socialAccountName, channelId, allowRemove}) ->
    @sourceId = sourceId
    @sourceIndex = sourceIndex
    @socialAccountId = socialAccountId
    @socialAccountName = socialAccountName
    @channelId = channelId
    @allowRemove = allowRemove

  render: ->
    @$el.html @template
      id: @sourceId
      index: @sourceIndex
      provider: @provider
      sourceClassName: @sourceClassName
      sourceIcon: @sourceIcon
      channelClassName: @channelClassName
      socialAccountId: @socialAccountId
      socialAccountName: @socialAccountName
      channelId: @channelId
      allowRemove: @allowRemove
    @$el.attr('data-type', @provider)
    @
